define('v3/Common/Services/jwtService',[
	'jquery',
	'knockout',
	'env',
	'oidc-client',
	'v3/Common/Helpers/SignedCookies/requestSignedCookies'
], function ($, ko, env, Oidc, signedCookies) {
	var observableUserAccessToken = ko.observable();
	var accessToken;

	var mgr = new Oidc.UserManager({
		clockSkew: ((Date.now() - env.clientTimeOffset) / 1000),
		userStore: new Oidc.WebStorageStateStore({ store: window.localStorage }),
		authority: env.authentication.issuer,
		client_id: env.authentication.clientId,
		response_type: 'code',
		silent_redirect_uri: window.location.origin + '/Account/SilentRenew',
		accessTokenExpiringNotificationTime: 10,
		automaticSilentRenew: true,
		filterProtocolClaims: true,
		loadUserInfo: false,
		scope: env.authentication.scope
	});

	mgr.events.addSilentRenewError(function (e) {
		console.error('silent renew error', e.message);
		reAuthenticate();
	});
	mgr.events.addUserSignedOut(function () {
		console.error('user logged out of the token server');
		reAuthenticate();
	});
	mgr.events.addUserLoaded(function (u) {
		accessToken = u.access_token;
		observableUserAccessToken(u.access_token);

		// set access_token for backwards compatibility
		localStorage.setItem('access_token', u.access_token);
		signedCookies.requestSignedCookies(u.access_token, env.environment === 'production' ? 'prod' : 'master');
	});
	mgr.signinSilent();

	function reAuthenticate () {
		var current = location.pathname + location.search + location.hash;
		window.location.href = '/Account/ReLogOn?returnUrl=' + encodeURIComponent(current);
	}

	return {
		getAccessToken: function () {
			if (accessToken) {
				return $.Deferred().resolve(accessToken);
			}

			var defer = $.Deferred();
			var subscription = observableUserAccessToken.subscribe(function (accessToken) {
				defer.resolve(accessToken);
				subscription.dispose();
			});
			return defer;
		},
		getImpersonateToken: function () {
			return localStorage.getItem('impersonate_token');
		},
		setImpersonateToken: function (authToken) {
			localStorage.setItem('impersonate_token', authToken.access_token);
		},
		resetImpersonateToken: function () {
			localStorage.removeItem('impersonate_token');
		},
		refresh: function () {
			return mgr.signinSilent().then(function (user) {
				return $.Deferred().resolve(user.access_token);
			}, function (e) {
				return $.Deferred().reject(e);
			});
		}
	};
});

